<template>
  <v-layout
    v-if="!$apollo.loading && !nodata" 
    wrap
  >
    <v-flex 
      xs12
      md6
    >
      <v-menu
        offset-y
        right
        bottom
      >
        <template v-slot:activator="{ on }">
          <v-btn
            :class="!$vuetify.breakpoint.xs ? 'mr-2' : ''"
            :disabled="$apollo.loading"
            outlined 
            small
            text
            v-on="on"
          >
            {{ exchangeName }}
          </v-btn>
        </template>
        <v-sheet dense>
          <v-list-item
            v-for="(ex, i) in supportedExchanges"
            :key="i"
            @click="reload(ex.id,'exchange_id')"
          >
            <v-list-item-title>{{ ex.name }}</v-list-item-title>
          </v-list-item>
        </v-sheet>
      </v-menu>
    </v-flex>
    <v-flex 
      xs12
      md3
    >
      <v-menu
        v-model="PickerFrom"
        :close-on-content-click="false"
        :nudge-right="40"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="fromDate"
            :label="$t('globals.from')"
            prepend-icon="mdi-calendar"
            readonly
            v-on="on"
          />
        </template>
        <v-date-picker 
          v-model="params.fromDate" 
          min="2017-05-01"
          :locale="$i18n.locale"
          :max="params.toDate || $moment().format('YYYY-MM-DD')"
          @input="PickerFrom = false"
          @change="reload(params.fromDate, 'fromDate')"
        />
      </v-menu>
    </v-flex>
    <v-flex 
      xs12
      md3
    >
      <v-menu
        v-model="PickerTo"
        :close-on-content-click="false"
        :nudge-right="40"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="toDate"
            :label="$t('globals.to')"
            prepend-icon="mdi-calendar"
            readonly
            v-on="on"
          />
        </template>
        <v-date-picker 
          v-model="params.toDate" 
          :locale="$i18n.locale"
          :min="params.fromDate || '2017-05-01'"
          :max="$moment().format('YYYY-MM-DD')"
          @input="PickerTo = false"
          @change="reload(params.toDate, 'toDate')"
        />
      </v-menu>
    </v-flex>  
    <v-flex xs12>
      <bar-chart
        ref="chart"
        :chartdata="chartData"
        :chartoptions="chartOptions"
        :styles="ChartStyles"
      />
      
      <center class="performance_note">
        {{ $t('globals.statsUpdated') }}
      </center>
    </v-flex>
  </v-layout>
  <v-layout 
    v-else
    wrap
    class="not-found"
  > 
    <v-flex>
      <v-icon>mdi-ghost</v-icon>
      <p>PnL data is not avaliable yet</p>
    </v-flex>
  </v-layout>
</template>

<script>
import BarChart  from '@/charts/Bar.vue'
import { setTimeout } from 'timers';

const PORTFOLIO_PNL_SERIES_QUERY = require('@/graphql/queries/PortfolioPnLSeries.gql');
import EXCHANGES_QUERY from "@/graphql/queries/SupportedExchanges.gql";

export default {
  components: { 
    BarChart 
  },
  data() {
    return {
      name: 'PnLChart',
      PickerFrom: null,
      PickerTo: null,
      nodata: true,
      params: {
        exchange_id: '2',
        fromDate: this.$moment().subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss'),
        toDate: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
      },
    }
  },
  computed: {
    exchangeName() {
      if (!this.supportedExchanges) return
      return (this._.find(this.supportedExchanges, {
        id: this.params.exchange_id
      })).name;
    },
    fromDate() {
      return this.$moment(this.params.fromDate).format('ll');
    },
    toDate() {
      return this.$moment(this.params.toDate).format('ll');
    },
    ChartStyles() {
      return {
        height: `300px`,
        position: `relative`
      }
    },
    chartData() {
      return {
        labels: this.portfolioPnLSeries.labels,
        datasets: [{
          label: '',
          data: this.portfolioPnLSeries.datasets,
          backgroundColor: this.filterColors(this.portfolioPnLSeries.datasets)
        }],
        base_currency: this.portfolioPnLSeries.base_currency,
        format: this.$options.filters.formatMoney
      }
    },
    chartOptions() {
      return {
        legend: false,
        maintainAspectRatio: false,
        elements: {
          line: {
              borderColor: '#0436af',
              borderWidth: 1.4,
              tension: 0
          }
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
                return 'PnL: ' + data.format(tooltipItem.value) + ' ' + data.base_currency
            },
            labelTextColor: function(tooltipItem, chart) {
                return tooltipItem.value >= 0 ? '#75b211': '#d94040';
            },
            title: function(tooltipItem, chart) {
              return tooltipItem[0].label + ', ' + chart.datasets[0].label
            }
          }
        },
        scales: {
          yAxes: [{
            stacked: true,
            gridLines: {
              display: true,
              color: "#f6f8f9"
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              autoSkip: true,
              autoSkipPadding: 20,
              maxRotation: 0,
              callback: function(value, index, values) {
                  return value.substring(0, value.length-6);
              }
            }
          }]
        }
      } 
    }
  },
  methods: {
    changeSeries(data) {
      this.chartdata = {
        labels: data.labels,
        datasets: [{
          data: data.datasets,
        }]
      }
      
      if(this.$refs.chart !== undefined) {
        setTimeout(()=>{
           this.$refs.chart.render()
        },200)
      }
       
    },
    filterColors (values) {
      let colors = []
      values.forEach(item => {
        colors.push(item > 0 ? '#75b211' : '#d94040')
      })
      return colors
    },
    reload(value, from) {
      this.params[from] = value
      this.params.fromDate = this.$moment(this.params.fromDate).format('YYYY-MM-DD HH:mm:ss')
      this.params.toDate = this.$moment(this.params.toDate).format('YYYY-MM-DD HH:mm:ss')
      this.$apollo.queries.portfolioPnLSeries.fetchMore({
        variables: this.params,
        updateQuery: (previousResult, { fetchMoreResult }) => {
          this.changeSeries(fetchMoreResult)
          return fetchMoreResult
        },
      })
    },
  },
  apollo: {
    supportedExchanges: {
      query: EXCHANGES_QUERY
    },
    portfolioPnLSeries: {
      query: PORTFOLIO_PNL_SERIES_QUERY,
      variables() {
        return this.params
      },
      result(data) {
        if (data.loading == false) {
          this.changeSeries(data.data.portfolioPnLSeries)
          this.nodata = false
        }
      }
    }
  }
};
</script>

<style lang="scss">

.performance_note {
  margin: 8px 8px 0;
  display: block;
  color: #7f97ab;
  font-size: 0.78rem;
  i {
    font-size: 0.95rem;
  }
}
</style>
